import { render, staticRenderFns } from "./ReplyToMessage.vue?vue&type=template&id=bc48a1b4&scoped=true&"
import script from "./ReplyToMessage.vue?vue&type=script&lang=js&"
export * from "./ReplyToMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReplyToMessage.vue?vue&type=style&index=0&id=bc48a1b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc48a1b4",
  null
  
)

export default component.exports